import apiClient from '../../../services/apiClient';
import { TransformFilters } from '../../../utils';

export const TechnicalConceptAPI = {
  fetchMovements: async ({
    queryKey
  }: any) => {
    const [, filters] = queryKey;
    const transformedFilters = TransformFilters(filters)
    const { data } = await apiClient.get('/api/petition/concept', {
      params: {
        ...transformedFilters,
        paginate: true,
        page: filters?.page,
      },
    });
    return data;

  },


  // Crear una nueva solicitud de concepto con FormData
  createConceptPetition: async (conceptData: FormData) => {
    const { data } = await apiClient.post('/api/petition/concept', conceptData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  // Mostrar una solicitud de concepto por ID
  fetchConceptPetition: async (conceptId: string) => {
    const { data } = await apiClient.get(`/api/petition/concept/${conceptId}`);
    return data;
  },

  // Actualizar una solicitud de concepto
  updateConceptPetition: async (conceptId: string, conceptData: any) => {
    const { data } = await apiClient.put(`/api/petition/concept/${conceptId}`, conceptData);
    return data;
  },

  // Eliminar una solicitud de concepto
  deleteConceptPetition: async (conceptId: string) => {
    const { data } = await apiClient.delete(`/api/petition/concept/${conceptId}`);
    return data;
  },

  // Exportar todas las solicitudes de concepto
  exportConceptPetitions: async () => {
    const { data } = await apiClient.get('/api/petition/concept/export');
    return data;
  },

  // Generar un PDF de una solicitud de concepto
  generateConceptPDF: async (conceptId: string): Promise<void> => {
    try {
      const { data } = await apiClient.get(`/api/petition/concept/pdf/${conceptId}`);
      const { url: fileUrl, filename = 'Documento_concepto.pdf' } = data || {};

      if (!fileUrl) throw new Error('No se encontró la URL del documento.');

      const blob = await (await fetch(fileUrl)).blob();
      const downloadUrl = URL.createObjectURL(blob);

      const link = Object.assign(document.createElement('a'), {
        href: downloadUrl,
        download: filename,
      });

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error en generateConceptPDF:', error);
      throw error;
    }
  },

   downloadFileConceptZip: async (conceptId: string): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/concept/generate-proof/${conceptId}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Comprobante_documentos_Concepto.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error: any) {
      console.error('Error en downloadFiles:', error);
      throw error;
    }
  },

  // Descargar documentos como zip
  downloadFiles: async (conceptId: string, ticket: string): Promise<void> => {
    try {
      const response = await apiClient.get<Blob>(
        `/api/petition/concept/documents/${conceptId}`,
        {
          responseType: 'blob',
        }
      );

      const zipBlob = response as unknown as Blob;
      const url = window.URL.createObjectURL(zipBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Listado_documentos_Concepto_${ticket}.zip`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

    } catch (error: any) {
      console.error('Error en downloadFiles:', error);
      throw error;
    }
  },

  downloadConceptDocuments: async (conceptId: string) => {
    const { data } = await apiClient.get(`/api/petition/concept/documents/${conceptId}`, {
      responseType: 'blob',
    });
    return data;
  },

  // Administrar una solicitud de concepto
  manageConceptPetition: async (conceptId: string, payload: any) => {
    const { data } = await apiClient.put(`/api/petition/concept/manage/${conceptId}`, payload);
    return data;
  },

  // Administrar los elementos de una solicitud de concepto
  manageConceptPetitionItems: async (itemId: string, payload: any) => {
    const { data } = await apiClient.put(`/api/petition/concept/manageItems/${itemId}`, payload);
    return data;
  },

  // Evaluar los elementos de una solicitud de concepto
  evaluateConceptPetitionItems: async (evaluationId: string, payload: any) => {
    const { data } = await apiClient.post(`/api/petition/concept/evalItems/${evaluationId}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },

  fetchParameters: async (keys: string[], filters?: Record<string, string>) => {
    try {
      const queryParams = keys
        .map((key) => `keys[]=${encodeURIComponent(key)}`)
        .join('&');

      let filterParams = '';
      if (filters) {
        filterParams = Object.entries(filters)
          .map(([key, value]) => `filter[${encodeURIComponent(key)}]=${encodeURIComponent(value)}`)
          .join('&');
      }

      const queryString = `${queryParams}${filterParams ? '&' + filterParams : ''}`;
      const { data } = await apiClient.get(`api/utils/select-tables?${queryString}`);

      return data;
    } catch (error) {
      console.error('Error fetching parameters:', error);
      return null;
    }
  },
  // Anadir los elementos de una solicitud de concepto
  addEvaluationItems: async (evaluationId: string, payload: any) => {
    const { data } = await apiClient.post(`/api/petition/concept/addEval/${evaluationId}`, payload);
    return data;
  },
};